<h1 matDialogTitle>{{ "CONFIRM_DIALOG.CONFIRM" | translate }}</h1>
<div mat-dialog-content>
  {{this.confirmMessage}}
</div>
<div mat-dialog-actions class="pt-24">
  <button mat-raised-button class="mat-accent mr-4" (click)="save()" cdkFocusInitial
    color="accent">{{ "CONFIRM_DIALOG.OK" | translate }}</button>
  <button mat-button (click)="onNoClick()">{{ "CONFIRM_DIALOG.CANCEL" | translate }}</button>
</div>
